import styled from 'styled-components';
import { ModalBody, ModalFooter } from 'reactstrap';

export const LandAdvisorModalBody = styled(ModalBody)`
  background: #f8f9fb;
  border-radius: 12px;
  padding: 1.5rem;
  color: #23272f;
  font-size: 1em;
  .info {
    color: #4b5563;
    font-weight: 500;
    margin-bottom: 0.75rem;
  }
  .warning-label {
    color: #b68900;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
    letter-spacing: 0.01em;
  }
  .warning {
    color: #b68900;
    background: #fffbe6;
    border-radius: 6px;
    padding: 0.5em 0.75em;
    margin-bottom: 0.5em;
  }
  .error-label {
    color: #c0392b;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
    letter-spacing: 0.01em;
  }
  .error {
    color: #c0392b;
    background: #fff0f0;
    border-radius: 6px;
    padding: 0.5em 0.75em;
    margin-bottom: 0.5em;
  }
`;

export const LandAdvisorModalFooter = styled(ModalFooter)`
  background: #f8f9fb;
  border-top: 1px solid #e9ecef;
  padding: 0.75rem 1.5rem;
  border-radius: 0 0 12px 12px;
`;
